'use client';
export const isSERVER = typeof window === 'undefined';

export const clearLocalStorageCart = () => {
  if (isSERVER) return;
  localStorage.removeItem('cart');
};

export const addToLocalStorageCart = (productId: number) => {
  if (isSERVER) return;
  if (!productId) return;
  const prev = localStorage.getItem('cart');
  if (!prev) {
    localStorage.setItem('cart', JSON.stringify([productId]));
    return;
  }
  const arr = JSON.parse(prev);
  if (arr.includes(productId)) {
    return;
  }
  arr.push(productId);
  localStorage.setItem('cart', JSON.stringify(arr));
};

export const removeFromLocalStorageCart = (productId: number) => {
  if (isSERVER) return;
  const prev = localStorage.getItem('cart');
  if (!prev) {
    return;
  }
  const arr = JSON.parse(prev);
  const index = arr.indexOf(productId);
  if (index > -1) {
    arr.splice(index, 1);
  }
  localStorage.setItem('cart', JSON.stringify(arr));
};

export const getLocalStorageCart = () => {
  if (isSERVER) return;
  const cart = localStorage.getItem('cart');
  if (!cart) {
    return [];
  }
  return JSON.parse(cart);
};

export const getLocalStorageCartCount = () => {
  return getLocalStorageCart().length;
};

export const checkInCartLocalStorage = (masterclassId: number) => {
  if (isSERVER) return;
  const cart = getLocalStorageCart();
  return cart.includes(masterclassId);
};
